module.exports = __webpack_public_path__ + "static/media/fidelidade.bda02ca7.png";